import React from "react";

const LuxuryPlusCarWash = () => {
  return (
    <div>
      <div>
        <p className="mt-2 mb-2 font-bold">
          Advanced Interior Detailing (Chemical Wash) & Exterior Foam Wash
        </p>
        <ul className="list-disc text-black-500 font-bold">
          <li>Free Air Freshener</li>
        </ul>
        <ul className="list-disc text-black-500 ">
          <li>Car Roof Cleaning</li>
          <li>Foot Mat, Tissue Paper, Air Freshener</li>
          <li>Interior Special Foam Wash</li>
          <li>Interior Chemical Wash</li>
          <li>High Pressure Foam Wash</li>
          <li>Premium Foam Car Shampoo</li>
          <li>Interior Deep Cleaning</li>
          <li>High Pressure Vacuum</li>
          <li>Dashboard & Interior Polish - Showroom Quality</li>
          <li>Tyre Polish - Showroom Quality</li>
          <li>Showroom Quality Exterior Polish</li>
          <li>
            <b>
              6-7 Seater will be charged Rs 200 extra and 7+ Seater will be
              charged Rs 400 extra
            </b>
          </li>
          <li>
            <b>
              CLEANING INSIDE BONNET IS AT OWNER'S RISK. - NOT RECOMMENDED (RS
              100 EXTRA)
            </b>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default LuxuryPlusCarWash;


